import getInYourBagCount from '@tcp/core/src/queries/getInYourBagCount.query.graphql';
import { executeStatefulGraphQLQuery } from '../../handler';
import logger from '../../../utils/loggerInstance';

const RES_NULL_ERROR = 'res body is null';
const DefaultTTL = 30;

const writeQuery = (cache, data) => {
  cache.writeQuery({
    query: getInYourBagCount,
    data,
  });
};

/**
 *
 * @param {boolean} skipCache: if skipCache = true then, it will hit the API else it will return the data from cache.
 * @param {number} cacheTTL: after how much time data needs to be refresh.s
 * @returns {object} response from the graphQL api.
 */
export async function inYourBagItemsStateFulCall(skipCache = false, cacheTTL) {
  return executeStatefulGraphQLQuery({
    query: getInYourBagCount,
    type: 'query',
    cacheConfigKey: 'GET_INVENTORY_AND_CART_DETAILS',
    TTL: cacheTTL || DefaultTTL,
    updateQuery: writeQuery,
    fetchPolicy: skipCache ? 'network-only' : '',
  })
    .then((res) => {
      if (!res?.data) {
        throw new Error(RES_NULL_ERROR);
      }
      return res?.data;
    })
    .catch((err) => {
      throw err;
    });
}

export async function getInYourBagItems(skipCache) {
  try {
    return await inYourBagItemsStateFulCall(skipCache);
  } catch (error) {
    logger.error({
      error,
      extraData: {
        title: 'An error occurred while calling GraphQl API in BundleProduct',
        componentName: 'BundleProduct.js',
        methodName: 'getInYourBagItems',
        payload: skipCache,
      },
    });
    return null;
  }
}
